import * as React from 'react';

function AttachmentIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M15.7031 7.21779V15.2411C15.7031 17.2879 14.0438 18.9472 11.997 18.9472C9.95017 18.9472 8.2909 17.2879 8.2909 15.2411L8.2909 7.21778C8.2909 5.85324 9.39708 4.74706 10.7616 4.74706C12.1262 4.74706 13.2323 5.85324 13.2323 7.21778L13.228 15.2454C13.228 15.9277 12.6749 16.4808 11.9926 16.4808C11.3103 16.4808 10.7573 15.9277 10.7573 15.2454L10.7616 7.83765"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round" />
    </svg>
  );
}

export default React.memo(AttachmentIcon);
